import { formatDate } from '@strata/helper-functions';
import { GridWithSearch, SecondaryData } from '@strata/react-grid';
import { HomeScreen, UpdatesSection } from '@strata/react-page-templates';
import { Fragment } from 'react';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import {
    ApplicationDisplayTextMap,
    formatDisplayColText,
} from 'pages/homeScreenMessaging/HomeScreenHelpers';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = [
    {
        header: 'Published Date',
        accessorKey: 'publish_date',
        size: 130,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        header: 'Message',
        accessorKey: 'message',
        size: 420,
        cell: ({ getValue }) => (
            <SecondaryData
                data={getValue()?.[0]?.messages?.[0]}
                customTooltipContent={getValue()?.map((section) => (
                    <Fragment key={section}>
                        <div>{UpdatesSection.TypeDisplayTextMap[section.update_type]}</div>
                        <ul>
                            {section.messages?.map((sectionMsg) => (
                                <li key={sectionMsg}>{sectionMsg}</li>
                            ))}
                        </ul>
                    </Fragment>
                ))}
            />
        ),
    },
    {
        header: 'Applications',
        accessorKey: 'application',
        size: 160,
        cell: ({ getValue }) => <SecondaryData data={ApplicationDisplayTextMap[getValue()]} />,
    },
    {
        header: 'Display',
        accessorKey: 'display',
        size: 80,
        cell: ({ getValue }) => <SecondaryData data={formatDisplayColText(getValue())} />,
    },
    { header: 'Created By', accessorKey: 'created_by', size: 250 },
    { header: 'Last Modified By', accessorKey: 'last_modified_by', size: 250 },
];

export const UpdateList = () => {
    const navigate = useNavigate();

    const messages = useGet(
        `/announcement/admin/home_screen/message/type/${HomeScreen.MessageType.UPDATE}`,
    );

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Updates"
                buttons={[
                    {
                        label: 'Create Update',
                        path: `/home-screen-messaging/updates/${CREATE_ROUTE}`,
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={messages}
                    isLoading={!messages}
                    columns={columns}
                    sortProperties={[{ id: 'publish_date', desc: true }]}
                    onRowClick={(row) =>
                        navigate(`/home-screen-messaging/updates/${row.message_id}`)
                    }
                />
            </div>
        </div>
    );
};
